// DraftPromptDialog.js
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  draftPromptModal: {
    minWidth: 400,
  },
  modalTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
  },
}));

const DraftPromptDialog = ({
  open,
  onClose,
  onContinueDraft,
  onNewForm,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="draft-prompt-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        id="draft-prompt-dialog-title"
        className={classes.modalTitle}
      >
        Saved Draft Found
      </DialogTitle>
      <DialogContent className={classes.draftPromptModal}>
        <Typography variant="body1" paragraph>
          We found a previously saved draft for this form. Would you like to
          continue with the draft or start a new form?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onNewForm} color="default">
          Start New Form
        </Button>
        <Button onClick={onContinueDraft} color="primary" variant="contained">
          Continue Draft
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DraftPromptDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContinueDraft: PropTypes.func.isRequired,
  onNewForm: PropTypes.func.isRequired,
};

export default DraftPromptDialog;
